export default __webpack_public_path__ + "static/media/woman2.3941e7bc.png";